<template>
  <div>
    <Header />
    <HeaderResponsive />
    <div class="container">
      <SecondHeader />
      <p class="title_section">Crear nueva experiencia</p>
      <p>
        Gracias por hacerte parte de este gran equipo, te invitamos a dejar tu
        experiencia asociada a la adpatación
      </p>
      <p>
        al cambio climático. En poco tiempo nuestros profesionales se
        comunicarán contigo
      </p>

      <div class="row form-experience" v-if="form1">
        <div class="col-md-12 col-sm-12">
          <p>
            <strong
              >Por favor llena todos los campos para poder continuar con el
              registro</strong
            >
          </p>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="form-group">
            <label for="username">Nombre *</label>
            <input
              type="text"
              name="username"
              :class="{
                'is-invalid': errors.has('step1.username'),
                'form-control': true,
              }"
              placeholder="Nombre (100 caracteres)"
              v-model="formValues.username"
              v-validate="'required|max:100'"
              data-vv-scope="step1"
              @keydown="truncateInputs($event, 50)"
              tabindex="1"
            />
            <div v-if="errors.has('step1.username')" class="has-error">
              Campo obligatorio
            </div>
          </div>
          <div class="form-group">
            <label for="municipality">Municipio *</label>

            <MunicipalitySelect
              :error="formValues.locationMunId === 0 && intents > 0"
              v-bind:municipality_id="formValues.locationMunId"
              v-bind:filter="formValues.locationId"
              v-bind:onClick="updateMun"
            />
            <div
              v-if="formValues.locationMunId === 0 && intents > 0"
              class="has-error"
            >
              Campo obligatorio
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="form-group">
            <label for="email">Correo *</label>
            <input
              type="email"
              name="email"
              :class="{
                'is-invalid': errors.has('step1.email'),
                'form-control': true,
              }"
              placeholder="Correo (100 caracteres)"
              v-model="formValues.email"
              v-validate="'required|email'"
              data-vv-scope="step1"
              @keydown="truncateInputs($event, 50)"
              tabindex="2"
            />
            <div v-if="errors.has('step1.email')" class="has-error">
              Campo obligatorio
            </div>
          </div>
          <div class="form-group">
            <label for="phone1">Teléfono 1 *</label>
            <input
              type="text"
              name="phone1"
              :class="{
                'is-invalid': errors.has('step1.phone1'),
                'form-control': true,
              }"
              placeholder="Telefono 1 (13 caracteres)"
              v-model="formValues.phone1"
              maxlength="13"
              data-vv-scope="step1"
              @keydown="truncateNumber($event, 14)"
              v-validate="{
                required: formValues.phone1,
                max: 13,
                regex: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/,
              }"
              tabindex="5"
            />
            <div v-if="errors.has('step1.phone1')" class="has-error">
              Campo obligatorio
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="form-group">
            <label for="locationId">Departamento *</label>

            <DepartamentsSelect
              :error="formValues.locationId === 0 && intents > 0"
              v-bind:departament_id="formValues.locationId"
              v-bind:onClick="updateDep"
            ></DepartamentsSelect>
            <div
              v-if="formValues.locationId === 0 && intents > 0"
              class="has-error"
            >
              Campo obligatorio
            </div>
          </div>
          <div class="form-group">
            <label for="phone2">Teléfono 2</label>

            <input
              type="text"
              name="phone2"
              :class="{
                'is-invalid': errors.has('step1.phone2'),
                'form-control': true,
              }"
              placeholder="Telefono 2 (13 caracteres)"
              v-model="formValues.phone2"
              v-validate="{ required: false, max: 13, regex: /^.{0,13}$/ }"
              data-vv-scope="step1"
              tabindex="6"
              @keydown="truncateInputs($event, 14)"
            />
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="form-group">
            <label for="locationId">Nombre de tu experiencia *</label>
            <textarea
              placeholder="Nombre de tu experiencia (1000 caracteres)"
              name="longName"
              :class="{
                'is-invalid': errors.has('step1.longName'),
                'form-control': true,
              }"
              cols="30"
              rows="3"
              v-model="formValues.longName"
              data-vv-scope="step1"
              v-validate="'required|max:1000'"
              @keydown="truncateInputs($event, 1000)"
              tabindex="7"
            ></textarea>
            <div v-if="errors.has('step1.longName')" class="has-error">
              Campo obligatorio
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="form-group">
            <label for="locationId">Descripción de la medida *</label>
            <textarea
              placeholder="Descripción de la medida (1000 caracteres)"
              name="measureDescription"
              :class="{
                'is-invalid': errors.has('step1.measureDescription'),
                'form-control': true,
              }"
              cols="30"
              rows="3"
              v-model="formValues.measureDescription"
              data-vv-scope="step1"
              v-validate="'required|max:1000'"
              @keydown="truncateInputs($event, 1000)"
              tabindex="8"
            ></textarea>
            <div
              v-if="errors.has('step1.measureDescription')"
              class="has-error"
            >
              Campo obligatorio
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" style="margin-top: 20px;">
          <div class="form-group text-center">
            <input type="checkbox" id="checkbox" v-model="terminos" />
            <a @click="terms()"
              >&nbsp;&nbsp; Acepto Términos, Condiciones y política de
              tratamiento de datos.</a
            >
            <div v-if="!terminos" class="red">
              (*)
            </div>
          </div>
        </div>

        <div class="container_btn">
          <div class="form-group text-center">
            <vue-recaptcha sitekey="6Lc93LAUAAAAACfYBg3D5rnnqeLn00oklO7w1bJH">
              <button
                @click="alert"
                class="btn btn-info btn-aceptar btn-save"
                :disabled="!terminos_success"
              >
                Guardar
              </button>
            </vue-recaptcha>
          </div>
        </div>
      </div>

      <div class="row form-experience" v-if="form2">
        <div class="col-md-4 col-sm-12">
          <div class="form-group">
            <label for="locationId">Nivel de adpatación</label>

            <AdaptationLevelSelect
              v-bind:objective_id="adaptationLvl"
              v-bind:onClick="updateAdpLvl"
            />
          </div>
          <div class="form-group"></div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="form-group">
            <label for="locationId">Amenazas</label>

            <ThreatsSelect v-bind:onClick="updateThreat" />
          </div>
          <div class="form-group"></div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="form-group">
            <label for="locationId">Gremmio</label>

            <GuildSelect v-bind:onClick="updateGuild" />
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="form-group">
            <textarea
              name="mensaje"
              placeholder="Experiencia personal "
              class="form-control"
              cols="30"
              rows="3"
              v-model="formValues.measureDescription"
              data-vv-scope="step2"
              v-validate="'required|max:100'"
            ></textarea>
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="form-group">
            <textarea
              name="mensaje"
              placeholder="Objetivo de la experiencia "
              class="form-control"
              cols="30"
              rows="3"
              v-model="formValues.measureDescription"
              data-vv-scope="step2"
              v-validate="'required|max:100'"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <Footer />

    <modal name="experiencias">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 text-center">
            <p class="p_modal">
              Gracias por compartir la experiencia
              <span style="color: #3366CC;">{{
                this.formValues.longName
              }}</span>
            </p>
            <p class="p_modal">
              que está registrada bajo el código
              <span style="color: #3366CC;">EXP-{{ this.id }}</span>
            </p>
            <p class="p_modal">
              en poco tiempo nuestros profesionales se van a comunicar contigo.
            </p>
            <hr />
            <p class="p_modal_details">
              Vía correo electrónico llegará la notificación de la apertura de
              esta solicitud.
            </p>
            <p class="p_modal_details">
              Si requieres más información puedes contactarte con nosotros o
              comunicarte con los siguientes medios:
            </p>

            <p class="p_modal_details">
              Línea de atención al ciudadano nacional gratuita:
              {{ $store.state.footer.phone }}
            </p>
            <p class="p_modal_details">
              Correo electrónico institucional: {{ $store.state.footer.email }}
            </p>
            <p class="p_modal_details">{{ $store.state.footer.schedule }}</p>
            <button
              type="button"
              class="btn btn-primary width50"
              @click="closeModal()"
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </modal>
    <sweet-modal ref="modalSuccess" icon="success">
      {{ message }}
    </sweet-modal>
    <sweet-modal ref="modalError" icon="error">
      {{ message }}
    </sweet-modal>
  </div>
</template>

<script>
import Header from "./partials/Header";
import SecondHeader from "./partials/SecondHeader";
import HeaderResponsive from "./partials/HeaderResponsive";
import Footer from "./partials/Footer";
import Terms from "./Terms";
import DepartamentsSelect from "./selects2/DepartamentsSelect";
import MunicipalitySelect from "./selects2/MunicipalitysSelect";
import AdaptationLevelSelect from "./selects2/AdaptationLevelsSelect";
import ThreatsSelect from "./selects2/ThreatsSelect";
import GuildSelect from "./selects2/GuildsSelect";
import VueRecaptcha from "vue-recaptcha";

import axios from "axios";
import config from "../../helpers/config";
import truncateInputs from "../../helpers/truncateInputs";
import truncateNumber from "../../helpers/truncateNumber";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import fakePromise from "../../helpers/fakePromise";

export default {
  components: {
    Header,
    SecondHeader,
    HeaderResponsive,
    Footer,
    Terms,
    DepartamentsSelect,
    MunicipalitySelect,
    AdaptationLevelSelect,
    ThreatsSelect,
    GuildSelect,
    VueRecaptcha,
    SweetModal,
    SweetModalTab,
  },
  data() {
    return {
      message: "",
      intents: 0,
      id: null,
      name: null,
      formValues: {
        locationMunId: 0,
        locationId: 0,
        username: "",
        longName: "",
        name: "",
      },
      filter: 0,
      objective: null,
      terminos: false,
      btn_next: false,
      form1: true,
      form2: false,
      adaptationLvl: [],
      threat: [],
      msg: "",
      recaptchaVerified: false,
    };
  },
  methods: {
    onVerify: function(token) {
      /*
      axios.post('https://www.google.com/recaptcha/api/siteverify', {
        secret: '6Lc93LAUAAAAAJHme47SXyeG4w80XROTLM5Cw57m',
        response: token
      }).then(res => {
        this.recaptchaVerified = res.data.success;

        console.clear();
        console.log(this.recaptchaVerified);
        debugger;

      }).catch(err => {
        console.log(err);
      })
       */
    },
    truncateNumber: (evt, n) => truncateNumber(evt, n),
    truncateInputs: (evt, n) => truncateInputs(evt, n),
    closeModal() {
      this.$router.push({ name: "Index" });
      //this.$modal.hide('experiencias')
    },
    openMessage(status, message) {
      this.message = message;
      if (status) {
        this.$refs.modalSuccess.open();
      } else {
        this.$refs.modalError.open();
      }
    },
    alert(data) {
      fakePromise(2000)(true)
        .then((res) => {
          this.recaptchaVerified = res;

          if (this.recaptchaVerified) this.check();
          else
            this.openMessage(
              false,
              "La verificación del reCAPTCHA no fue exitosa."
            );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateDep(id) {
      this.formValues.locationId = id;
    },
    updateMun(id) {
      this.formValues.locationMunId = id;
    },
    updateAdpLvl(dep) {
      this.adaptationLvl = dep;
    },
    updateThreat(dep) {
      this.threat = dep;
    },
    updateGuild(dep) {
      this.formValues.guildId = dep;
    },
    form2_activate() {
      this.validateBeforeSubmit("step1").then((result) => {
        if (result) {
          this.form1 = false;
          this.form2 = true;
        }
      });
    },
    back() {
      this.form2 = false;
      this.form1 = true;
    },
    validateBeforeSubmit(scope) {
      //console.log(scope);
      return this.$validator.validateAll(scope).then((result) => {
        return result;
      });
    },
    check() {
      this.intents++;
      console.log("check");
      this.validateBeforeSubmit("step1").then((result) => {
        console.log("result");
        console.log(result);
        if (result) {
          if (!this.terminos) {
            this.openMessage(
              0,
              "Por favor verifique que todos los campos obligatorios estén diligenciados y vuelva a intentarlo."
            );
          } else {
            this.save();
          }
        }
      });
    },
    save() {
      const l1 = this.formValues.phone1.length;
      const l2 = this.formValues.phone2 ? this.formValues.phone2.length : 8;
      if (l1 >= 7) {
        const threatSubIds = this.threat
          .filter((item) => {
            return !Number.isInteger(item);
          })
          .map((item) => {
            return parseInt(item.split(":")[1]);
          });
        const adaptSubIds = this.adaptationLvl
          .filter((item) => {
            return !Number.isInteger(item);
          })
          .map((item) => {
            return parseInt(item.split(":")[1]);
          });
        const payload = {
          threatSubIds: threatSubIds,
          adaptSubIds: adaptSubIds,
          ...this.formValues,
        };
        axios
          .post(`${config.urlApi}/experiences/SendExpConfirm`, {
            data: payload,
          })
          .then((response) => {
            this.id = response.data.id;
            this.$modal.show("experiencias");
            this.formValues = {
              locationMunId: 0,
              locationId: 0,
              username: "",
              longName: "",
              email: "",
              measureDescription: "",
              name: "",
            };
            this.terminos = false;
            this.updateDep(0);
          })
          .catch((e) => {
            console.error(e);
          });
      } else {
        //console.log('error')
        this.openMessage(0, "El telefono debe contener de 7 a 11 caracteres");
      }
    },
    terms() {
      this.$modal.show("terms");
    },
  },
  computed: {
    form1_ready() {
      if (
        this.name !== null &&
        this.name !== "" &&
        this.experience_name !== null &&
        this.experience_name !== "" &&
        this.phone_1 !== null &&
        this.phone_1 !== "" &&
        this.email !== null &&
        this.email !== "" &&
        this.description !== null &&
        this.description !== ""
      ) {
        return true;
      }
    },
    form1_success() {
      return this.validateBeforeSubmit("step1");
    },
    form2_success() {
      return this.validateBeforeSubmit("step2");
    },
    terminos_success() {
      if (this.terminos == true) {
        return true;
      }
    },
  },
};
</script>

<style>
.container_btn {
  width: 60%;
  margin: auto;
}
.title_section {
  color: #3366cc;
  font-weight: bolder;
  font-size: 2em;
  padding-bottom: 20px;
}
.btn-aceptar {
  width: 250px;
  background: #3366cc !important;
  color: #fff !important;
  margin-top: 20px;
}
.btn-aceptar:hover {
  cursor: pointer;
}
.btn-back {
  width: 250px;
  background: #b1b2b3 !important;
  color: #fff !important;
  margin-top: 20px;
  border-color: #b1b2b3 !important;
}
.btn-back:hover {
  cursor: pointer;
}
.btn-save {
  margin-right: 10px;
}
.container > p {
  line-height: 0.4;
}
.form-experience {
  margin-top: 50px !important;
}
.p_modal {
  font-size: 22px;
}
.width50 {
  width: 50%;
}
.p_modal_details {
  margin-bottom: 0.4rem;
}

.red {
  color: red;
  position: absolute;
  right: 24%;
  width: 17px;
  top: -0.1em;
}

.has-error {
  color: #dc3545;
}
</style>
